import React, { useState } from 'react';
import { FDStack } from '@facet-wealth/design';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import MetaFormInline from 'Components/UI/Meta/MetaForm/Components/MetaFormInline';
import { metaOverrideSet } from 'Views/Page/Content/Templates/accountMissingInformationTemplate/metaOverrideSet';
import { AccountItem } from './accountItem';

const AccountList = () => {
  const { resource } = useMetaLayoutContext();
  const [expandedID, setExpandedID] = useState(resource.attr('accounts').resources().head()?.id());

  return (
    <FDStack direction="column">
      {resource.attr('accounts').resources().list().map((el) => (
        <MetaFormInline
          key={el.id()}
          resource={el}
          layout={AccountItem}
          LayoutProps={{
            hideErrorList: true,
            expanded: expandedID === el.id(),
            setExpanded(expanded) {
              if (!expanded) {
                return; // Don't let anyone manually close one of these
              }
              setExpandedID(el.id());
            },
          }}
          metaOverrideSet={metaOverrideSet}
          padding="none"
          margin="none"
          noIndividualSubmitButtons
          noIndividualDeleteButtons
        />
      ))}
    </FDStack>
  );
};

export default AccountList;
